import { loadQuery } from 'react-relay';
import { getAccountId } from 'lib/utils/authentication';
import { PAYMENTS_PAGINATION_QUERY } from 'services/payment/payment.relay.services';
import { paymentsPaginationQuery } from 'services/payment/__generated__/paymentsPaginationQuery.graphql';
import RelayEnvironment from 'lib/utils/relay';

export const TalkPaymentsPreloadData = () => {
  const accountId = getAccountId();

  return {
    paymentsQueryRef: loadQuery<paymentsPaginationQuery>(
      RelayEnvironment,
      PAYMENTS_PAGINATION_QUERY,
      {
        first: 500,
        filter: {
          where: {
            accountId: { equalTo: accountId },
            deletedAt: { isNull: true },
          },
        },
        ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
        skip: !accountId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type TalkPaymentsPreloadDataType = ReturnType<typeof TalkPaymentsPreloadData>;
